import { useContext } from 'react'
import { LoadingContext } from 'context/LoadingContext'


function LoadingSendForm({customClass = false, children}) {
  const [isLoading] = useContext(LoadingContext)

  if(isLoading)
    return (
      <div className={"loading-send-form "+(customClass ?? '')}>
        <div className="cssload-container">
          <div className="cssload-zenith"></div>
        </div>
        <div className="overlay"></div>{children}
      </div>
    )
  else
    return children
}

export default LoadingSendForm